import { Button, Drawer, Row, Space, Tooltip } from 'antd';
import i18next from "i18next";
import Icon from '@ant-design/icons';
import { ReactComponent as filter_icon } from '../../../../assets/images/esri/filter-32.svg'
import { ReactComponent as magnifying_glass_icon } from '../../../../assets/images/esri/magnifying-glass-32.svg'
import { ReactComponent as view_visible_icon } from '../../../../assets/images/esri/view-visible-32.svg'
import { ReactComponent as table_icon } from '../../../../assets/images/esri/table-32.svg'
import { useDispatch, useSelector } from "react-redux";
import { table_state, addTableName } from "../../../../features/table/tableSlice";
import { addQueryofTable } from '../../../../features/queries/queriesSlice';


import Graphic from '@arcgis/core/Graphic';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';


const FeatureToolbarComponent = ({ mapDiv, mapView, table, feature, mapLayer, sublayer }) => {

    const dispatch = useDispatch();
    const tableState = useSelector(table_state);

    const renderIcon = (tool) => {
        switch (tool) {
            case 'filter':
                return <Icon component={filter_icon} />
            case 'zoom':
                return <Icon component={magnifying_glass_icon} />
            case 'add_geometry':
                return <Icon component={view_visible_icon} />
            case 'add_to_table':
                return <Icon component={table_icon} />
            default:
                return "?";
        }
    }

    const addGeometry = () => {
        let symbol;

        if (feature.geometry.declaredClass.toUpperCase().includes("POLYLINE")) {
            symbol = new SimpleLineSymbol({
                color: [51, 255, 233, 0.3],
                width: "15px",
                style: "solid"
            });
        }
        else if (feature.geometry.declaredClass.toUpperCase().includes("POLYGON")) {
            symbol = new SimpleFillSymbol({
                color: [51, 255, 233, 0.3],
                outline: {
                    color: [255, 255, 255],
                    width: 3,
                },
            });
        }
        else if (feature.geometry.declaredClass.toUpperCase().includes("POINT")) {
            symbol = new SimpleMarkerSymbol({
                style: "circle",
                size: "50px",
                color: [51, 255, 233, 0.3],
                outline: {
                    color: [255, 255, 255],
                    width: 3,
                },
            });
        }
        else {
            alert("TODO geometría no contemplada");
        }

        mapView.graphics.removeAll();
        const graphic = new Graphic({
            geometry: feature.geometry,
            symbol: symbol,
        });
        mapView.graphics.add(graphic);
    }
    const zoom = () => {
        if (feature.geometry.declaredClass.toUpperCase().includes("POINT")) {
            mapView.scale = 5000;
            mapView.goTo({
                target: feature.geometry,
                zoom: 15
            })
        }
        else {
            mapView.goTo(feature.geometry.extent.expand(1.5));
        }

        addGeometry();
    }

    const addToTable = () => {

        //Se contruye un objeto para la query y se pasa a la funcion addByFeature
        const queryCreator = {
            "findBy": "id",
            "content": feature
        }

        //console.log("sublayer en ventana", sublayer)

        //console.log("feature", feature.attributes)
        let attributeName = Object.keys(feature.attributes)[1]
        //console.log(`${attributeName} IN ('${feature.attributes[attributeName]}')`);
        dispatch(addQueryofTable(`${attributeName} IN ('${feature.attributes[attributeName]}') `))

        dispatch(addTableName(sublayer.title))

        table.addByFeature(mapView, mapLayer, sublayer, queryCreator)
    }
    return (
        <>

            <Tooltip title={i18next.t('common.toolbar.feature.zoom')} key={'common.toolbar.feature.zoom'}>
                <Button size='small'
                    onClick={() => zoom()}
                    type={'default'}>
                    {renderIcon('zoom')}
                </Button>
            </Tooltip>
            <Tooltip title={i18next.t('common.toolbar.feature.add_geometry')} key={'common.toolbar.feature.add_geometry'}>
                <Button size='small'
                    onClick={() => addGeometry()}
                    type={'default'}>
                    {renderIcon('add_geometry')}
                </Button>
            </Tooltip>
            {table && <Tooltip title={i18next.t('common.toolbar.feature.add_to_table')} key={'common.toolbar.feature.add_to_table'}>
                <Button size='small'
                    onClick={() => addToTable()}
                    type={'default'}>
                    {renderIcon('add_to_table')}
                </Button>
            </Tooltip>}
        </>
    )
};
export default FeatureToolbarComponent;